import { Listes } from "../Types/Listes";

export const grouperParPeriode = (items: Listes[]) => {
  const groupes: { [key: string]: Listes[] } = {
    "Aujourd'hui": [],
    "Hier": [],
    "Cette semaine": [],
    "Ce mois": [],
    "Plus ancien": [],
  };

  if (!Array.isArray(items)) {
    return groupes;
  }

  const maintenant = new Date();
  const aujourdHuiStr = maintenant.toLocaleDateString();

  const hier = new Date(maintenant);
  hier.setDate(hier.getDate() - 1);
  const hierStr = hier.toLocaleDateString();

  const jourSemaine = maintenant.getDay(); 
  const debutSemaine = new Date(maintenant);
  debutSemaine.setDate(
    maintenant.getDate() - (jourSemaine === 0 ? 6 : jourSemaine - 1)
  );

  const debutMois = new Date(maintenant.getFullYear(), maintenant.getMonth(), 1);

  

  for (const item of items) {
    const rawDate = typeof item.Date === "string" ? item.Date : item.Date?.date;
    const dateItem = new Date(rawDate);
    const itemStr = dateItem.toLocaleDateString();

    if (itemStr === aujourdHuiStr) {
      groupes["Aujourd'hui"].push(item);
    } else if (itemStr === hierStr) {
      groupes["Hier"].push(item);
    } else if (dateItem >= debutSemaine) {
      groupes["Cette semaine"].push(item);
    } else if (dateItem >= debutMois) {
      groupes["Ce mois"].push(item);
    } else {
      groupes["Plus ancien"].push(item);
    }
  }
  return groupes;
};